import { Tooltip as TooltipMaterial, tooltipClasses, TooltipProps } from '@mui/material';
import { memo, ReactElement } from 'react';
import { styled } from '@mui/material/styles';

const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <TooltipMaterial {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    marginTop: '-0.72em !important',
    '&::before': {
      border: `1px solid ${theme.palette.error.main}`,
      backgroundColor: '#fff',
      boxSizing: 'border-box',
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    background: '#fff',
    color: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
    fontSize: '1rem',
  },
}));

interface TooltipErrorProps {
  children: ReactElement;
  message?: string;
  show?: boolean;
}

const TooltipErrorComponent = ({
  children,
  message = '',
  show = false,
}: TooltipErrorProps): React.ReactElement => {
  return (
    <Tooltip style={{ zIndex: 2 }} title={show ? message : ''} arrow>
      {children}
    </Tooltip>
  );
};

TooltipErrorComponent.displayName = 'Tooltip Error component';

export const PmiTooltipError = memo(TooltipErrorComponent);

export default PmiTooltipError as typeof TooltipErrorComponent;
